'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _renderDeclaration = require('../renderers/renderDeclaration');

var _renderDeclaration2 = _interopRequireDefault(_renderDeclaration);

var _breakpointMapping = require('../utils/breakpointMapping');

var _formatting = require('../utils/formatting');

var _list = require('../utils/list');

var _predicate = require('../utils/predicate');

var _transformers = require('../utils/transformers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformGroups = function transformGroups(transformers, data, name) {
  return (0, _ramda.pipe)(_formatting.splitOnUnnestedComma, (0, _ramda.map)(_ramda.trim), (0, _ramda.map)((0, _ramda.pipe)(_formatting.splitOnUnnestedWhitespace, (0, _ramda.map)((0, _transformers.transformValue)(transformers, _ramda.__, data, name)), _formatting.joinWithSpace)), _formatting.joinWithCommaSpace);
};

var transform = function transform(transformers, name, data) {
  return (0, _ramda.ifElse)((0, _ramda.both)(_ramdaAdjunct.isString, _predicate.isGroups), transformGroups(transformers, data, name), (0, _transformers.transformValue)(transformers, _ramda.__, data, name));
};

var render = function render(propName, renderer) {
  return (0, _ramda.pipe)(_ramdaAdjunct.ensureArray, (0, _ramda.partial)(renderer, [propName]), _ramdaAdjunct.list);
};

var createDeclaration = function createDeclaration(propName, data, _ref, _ref2) {
  var _ref$transformers = _ref.transformers,
      transformers = _ref$transformers === undefined ? _ramda.identity : _ref$transformers,
      _ref$renderer = _ref.renderer,
      renderer = _ref$renderer === undefined ? _renderDeclaration2.default : _ref$renderer;
  var name = _ref2.name,
      query = _ref2.query,
      value = _ref2.value;
  return (0, _ramda.pipe)(transform(transformers, name, data), render(propName, renderer), (0, _breakpointMapping.createBreakpointMapping)(name, _ramda.__, query))(value);
};

var buildDeclarationReducer = function buildDeclarationReducer(propName, data, style) {
  return function (declarations, breakpointMapping) {
    return (0, _ramda.pipe)(createDeclaration, (0, _list.appendFlipped)(declarations))(propName, data, style, breakpointMapping);
  };
};

var buildDeclaration = function buildDeclaration(propName, data, style) {
  return (0, _ramda.reduce)(buildDeclarationReducer(propName, data, style), []);
};

exports.default = buildDeclaration;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/buildDeclaration.js
// module id = 642
// module chunks = 168707334958949